export const PAGINATION_PARAMS = {
    page: 1,
    offset: 20
};

export const NO_PAGINATION = {
    applyPagination: false,
    offset: 0,
    page: 0
};